import React from "react";
import {  useLocation, Navigate, Outlet } from "react-router-dom";
import jwtDecode from "jwt-decode";
import useAuth from "hooks/useAuth";

const RequireAuth  = ({ alloawedRoles }) => {
    const {accessToken} = useAuth();
    const decoded = accessToken ? jwtDecode(accessToken) : undefined;
    const roles    = decoded?.user.roles ? JSON.parse(decoded?.user.roles, true) :  [];
    const location = useLocation();
  return (
    /* eslint-disable */
    roles?.find( role => alloawedRoles?.includes(role))
      ? <Outlet/> 
      : accessToken
          ? <Navigate to="/" state={{ from:location }} replace/> 
          : <Navigate to="/dashboard/authentication/sign-in" state={{ from:location }} replace />
  )
}

export default RequireAuth